/*
 * Keeps the hidden properties[Presale] input in each product form in sync with
 * the variant actually being submitted, so presale items reach the cart,
 * checkout and order flagged as a reservation.
 *
 * Runs on submit (capture phase, before product-form.js builds its FormData)
 * instead of on variant change: the theme swaps the variant id input without
 * re-rendering the form, so reading it at submit time is the only reliable point.
 */
if (!window.pmaxPresalePropertyInit) {
  window.pmaxPresalePropertyInit = true;

  const syncPresaleProperty = (form) => {
    const input = form.querySelector('input[data-presale-property]');
    const map = form.querySelector('script[data-presale-labels]');
    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!input || !map || !variantId) return;

    let labels = {};
    try {
      labels = JSON.parse(map.textContent);
    } catch (error) {
      return;
    }

    const label = labels[variantId] || '';
    input.value = label;
    input.disabled = label === '';
  };

  document.addEventListener(
    'submit',
    (event) => {
      if (event.target instanceof HTMLFormElement) syncPresaleProperty(event.target);
    },
    true
  );

  // Dynamic checkout buttons read the form on click without firing submit.
  document.addEventListener(
    'click',
    (event) => {
      const form = event.target.closest?.('form');
      if (form?.querySelector('input[data-presale-property]')) syncPresaleProperty(form);
    },
    true
  );
}
